const ErrorLabel = ({ id, error }) => {
  return (
    <>
      <label
        htmlFor={id}
        className="font-normal text-[0.75rem] text-red-500 bg-white px-2 my-0 py-0 font"
      >
        {error}
      </label>
    </>
  );
};

export default ErrorLabel;
